// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { xScreen } from "@guestsupply/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;
// XNG-CHANGES
export interface ProductListControlsContainerStyles {
    container?: InjectableCss;
    countGridItem?: GridItemProps;
    countTableViewGridItem?: GridItemProps;
    sortGridItem?: GridItemProps;
    sortTableViewGridItem?: GridItemProps;
    filterGridItem?: GridItemProps;
    filterTableViewGridItem?: GridItemProps;
    viewSelectGridItem?: GridItemProps;
    viewSelectTableViewGridItem?: GridItemProps;
    // XNG-CHANGES
    sortAndFilterContainer?: InjectableCss;
    sortContainer?: InjectableCss;
    filterContainer?: InjectableCss;
    viewAndPaginationContainer?: InjectableCss;
    viewContainer?: InjectableCss;
}

export const controlsContainerStyles: ProductListControlsContainerStyles = {};

const styles = controlsContainerStyles;

// XNG-CHANGES: Change the structure
const ProductListControlsContainer: FC<Props> = ({ id, view }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.sortAndFilterContainer}>
                <StyledWrapper {...styles.sortContainer}>
                    <Zone contentId={id} zoneName="Content00" />
                </StyledWrapper>
                <StyledWrapper {...styles.filterContainer}>
                    <Zone contentId={id} zoneName="Content01" />
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.viewAndPaginationContainer}>
                <StyledWrapper {...styles.viewContainer}>
                    <Zone contentId={id} zoneName="Content02" />
                </StyledWrapper>
                <StyledWrapper>
                    <Zone contentId={id} zoneName="Content03" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListControlsContainer),
    definition: {
        group: "Product List",
        displayName: "List Controls Container",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
